import React from "react";
import { Form } from "react-bootstrap";
import { FormikProps } from "formik";
import { SimulatorTextField } from "../fields/SimulatorTextField";
import { FormValues } from "../types";

const FormSwitch = (Form as any).Switch;

interface GeneratorSectionProps {
  formik: FormikProps<FormValues>;
  resetGenerationConsume: (e: any) => void;
  resetDieselCost: (e: any) => void;
  resetGenerationCost: (e: any) => void;
}

export const GeneratorSection = ({
  formik,
  resetGenerationConsume,
  resetDieselCost,
  resetGenerationCost,
}: GeneratorSectionProps) => (
  <>
    <div>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <span className="simulacao-form-header">Dados de gerador</span>
        {/* <span style={{ color: "#7e7e82" }}>
          Caso não possua os dados do gerador, deixe os campos abaixo em branco,
          que calcularemos uma estimativa
        </span> */}
      </div>

      <hr />
    </div>

    <div className="formLine">
      <Form.Group
        controlId="gerador"
        style={{
          width: "100%",
          maxWidth: "375px",
          height: "80px",
          display: "flex",
          gap: "32px",
        }}
      >
        <Form.Label className="simulacao-form-title">
          Possui gerador?
        </Form.Label>
        <FormSwitch
          type="switch"
          name="isGerador"
          label=""
          value={formik.values.isGerador}
          onBlur={formik.handleBlur}
          onChange={formik.handleChange}
          checked={formik.values.isGerador}
        />
      </Form.Group>
    </div>

    {formik.values.isGerador && (
      <div className="formLine">
        <SimulatorTextField
          formik={formik}
          name="consumoGerador"
          controlId="simulationCNPJ"
          label="Consumo gerador"
          placeholder="Em kWh"
          unit="kWh"
          onChange={(e: any) => resetGenerationConsume(e)}
        />

        <SimulatorTextField
          formik={formik}
          name="custoDiesel"
          controlId="simulationCNPJ"
          label="Custo diesel (R$/kWh)"
          placeholder="Em reais"
          prefix="R$"
          onChange={(e: any) => resetDieselCost(e)}
        />

        <SimulatorTextField
          formik={formik}
          name="custoGerador"
          controlId="simulationCNPJ"
          label="Custo gerador"
          placeholder="Em reais"
          prefix="R$"
          onChange={(e: any) => resetGenerationCost(e)}
        />
      </div>
    )}
  </>
);
